const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div className="mb-8">
    <h2 className="mb-3 border-b border-white/[0.07] pb-2 text-base font-bold text-white">
      {title}
    </h2>
    {children}
  </div>
);

const T = ({ children }: { children: React.ReactNode }) => (
  <p className="mb-2 text-sm leading-[1.7] text-ak-muted">{children}</p>
);

import PageMeta from '../components/PageMeta';

const ImpressumPage = () => (
  <>
  <PageMeta title="Impressum" description="Impressum von AK TechSolutions – Alexander Krein." path="/impressum" noIndex />
  <section className="mx-auto max-w-[760px] px-8 py-[clamp(40px,7vw,72px)]">
    <h1 className="mb-10 text-[clamp(1.5rem,3vw,2rem)] font-bold text-white">Impressum</h1>

    <Section title="Angaben gemäß § 5 TMG">
      <address className="not-italic">
        <T>Alexander Krein</T>
        <T>TechSolutions</T>
        <T>Sägeweg 2</T>
        <T>79395 Neuenburg am Rhein</T>
      </address>
    </Section>

    <Section title="Kontakt">
      <address className="not-italic">
        <T>
          Telefon:{' '}
          <a href="tel:+4915157877989" className="text-ak-muted no-underline hover:text-ak-sky">
            +49 (0) 151 578 779 89
          </a>
        </T>
        <T>
          E-Mail:{' '}
          <a href="mailto:requests@aktechsolutions.de" className="text-ak-muted no-underline hover:text-ak-sky">
            requests@aktechsolutions.de
          </a>
        </T>
      </address>
    </Section>

    <Section title="Handwerksrechtliche Angaben">
      <T>Eingetragen in der Handwerksrolle: Elektro- und Informationstechnik</T>
      <T>Zuständige Handwerkskammer: Handwerkskammer Freiburg</T>
    </Section>

    <Section title="Umsatzsteuer">
      <T>
        Gemäß § 19 UStG wird keine Umsatzsteuer erhoben und daher auch nicht ausgewiesen
        (Kleinunternehmerregelung).
      </T>
    </Section>

    <Section title="Berufshaftpflichtversicherung">
      <T>Versicherungsträger: Exali AG</T>
      <T>Geltungsraum: Deutschland</T>
    </Section>

    <Section title="Haftung für Inhalte">
      <T>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den
        allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
        verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
      </T>
    </Section>

    <Section title="Haftung für Links">
      <T>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
        Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
        verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
      </T>
    </Section>

    <Section title="Urheberrecht">
      <T>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
        Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
      </T>
    </Section>
  </section>
  </>
);

export default ImpressumPage;
